import { Injectable } from '@angular/core';
import { LoadOptions } from 'devextreme/data';
import { ODataService } from 'projects/erp-app/src/app/core/services/oData.service';
import { ThirdContactInformation } from './third-contact-information.model';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'projects/erp-app/src/app/core/api.service';

@Injectable({
  providedIn: 'root'
})
export class ThirdContactInformationsService extends ODataService<ThirdContactInformation> {
  public url = 'ContactInformation';
  public override defaultOptions: LoadOptions = {
    expand: ['ContactTypeId', 'ThirdId', 'ContactQualifierId', 
    'AddressId.PostalCodeId', 'AddressId.LocalityId', 
    'AddressId.AddressTypeId', 'AddressId.ThirdId',
     'AddressId.LocalityId.CountryId'],
    sort: ['IsFavorite desc']
  };
  constructor( private api: ApiService,
    private translateService: TranslateService) {
    super();
  }

  public override format(element: ThirdContactInformation): any {
    var result: any = {
      ...element,
      ThirdId: element.ThirdId?.Id,
      AddressId: element.AddressId?.Id,
      ContactQualifierId: element.ContactQualifierId?.Id,
      ContactTypeId: element.ContactTypeId?.Id,
    };
    delete result.IsChecked
    return result;
  }

  public override async getInstance(params?: Partial<ThirdContactInformation>): Promise<ThirdContactInformation> {
    const third = new ThirdContactInformation({
      Value: this.translateService.instant("New value"),
      IsPublic: true,
      IsFavorite: false,
      UsedForQuote: true,
      UsedForDelivery: true,
      UsedForInvoice: true,
      UsedForNewsletter: true,
      ...params
    })
    return third;
  }
  public async removeThirdontactQualifier(elementId: number) {
    return await this.api.sendRequest('/api/odata/ContactInformation/' + elementId + '/ContactQualifierId/$ref', 'DELETE');
  }
}